import {InputAdornment} from '@mui/material';

// eslint-disable-next-line react/prop-types
const BrandedInputAdornment = ({children}) => {
  return (
    <InputAdornment
      position="end"
      sx={{
        '& .MuiTypography-root': {
          fontWeight: 'bold',
          color: 'primary.main',
          fontSize: 11
        }
      }}
    >
      {children}
    </InputAdornment>
  );
};

export default BrandedInputAdornment;
